module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0121.jpg?v=3ebaaf27";